import { Navigate } from 'react-router-dom';
import preloadChunks from '@/routes/preloadChunks.util';
import Auth from '@/pages/Auth';
import Login from '@/pages/Auth/Login';
import ForgotPassword from '@/pages/Auth/ForgotPassword';
import ForgotPasswordResult from '@/pages/Auth/ForgotPassword/ForgotPasswordResult';
import ResetPassword from '@/pages/Auth/ResetPassword';
import ResetPasswordSuccess from '@/pages/Auth/ResetPassword/ResetPasswordSuccess';
import Register from '@/pages/Auth/Register';
import InvitationWelcome from '@/pages/Auth/InvitationWelcome';
import IdAustriaReturnGate from '@/pages/SafeTransferAccess/IdAustriaReturnGate';

const authRoutes = [
  {
    path: 'auth',
    element: <Auth />,
    children: [
      { index: true, element: <Navigate to="login" replace /> },
      { path: 'invite', element: <InvitationWelcome /> },
      { path: 'login', element: <Login /> },
      {
        path: 'register',
        children: [
          { index: true, element: <Register /> },
          {
            path: 'verify-email',
            lazy: async () => ({
              Component: (await preloadChunks['auth.verifyEmail']()).default,
            }),
          },
          {
            path: 'account-type',
            lazy: async () => ({
              Component: (await preloadChunks['auth.accountType']()).default,
            }),
          },
          {
            path: 'kyc',
            lazy: async () => ({
              Component: (await preloadChunks['auth.kyc']()).default,
            }),
          },
          {
            path: 'idaustria',
            children: [{ path: 'callback', element: <IdAustriaReturnGate /> }],
          },
          {
            path: 'setpin',
            lazy: async () => ({
              Component: (await preloadChunks['auth.setPin']()).default,
            }),
          },
        ],
      },
      {
        path: 'forgotten-password',
        children: [
          { index: true, element: <ForgotPassword /> },
          { path: 'result', element: <ForgotPasswordResult /> },
        ],
      },
      {
        path: 'reset-password',
        children: [
          { index: true, element: <ResetPassword /> },
          { path: 'success', element: <ResetPasswordSuccess /> },
        ],
      },
    ],
  },
];

export default authRoutes;
